export default __webpack_public_path__ + "static/media/slide_3.b8124803.png";